<template>
  <div id="creator_agency">
    <van-nav-bar :title="$t('title.agency_center')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="22" offset="1" class="creator_agency_information_bg">
        <van-col span="24" class="creator_agency_information_bg_border">
          <van-col span="5"  class="creator_agency_information_bg_border_img">
            <van-image
                round
                width="12vw"
                height="12vw"
                :src="userinfo.head_image"
            />
          </van-col>
          <van-col span="18">
            <van-col span="24" class="creator_agency_information_bg_border_name"> {{ userinfo.nick_name }} </van-col>
            <van-col span="24" class="creator_agency_information_bg_border_id"> ID: <span id="creator_user_id">{{ userinfo.user_id }}</span><img src="../assets/img/creator/creator_agency_fz.png" @click="copyId()"/> </van-col>
          </van-col>
        </van-col>
        <van-col span="24" class="creator_agency_information_bg_office">
          <van-cell is-link>
            <template #title>
             <img src="../assets/img/creator/creator_agency_user.png" class="creator_agency_information_bg_office_img"/>
              <span class="custom-title">{{ $t('column.office_admin') }}</span>
            </template>
            <template #default>
              <span class="custom-title">{{ userinfo.country_name }}</span>
              <img :src="userinfo.country_img" class="creator_agency_information_bg_office_img2" v-if="userinfo.country_img"/>
            </template>
          </van-cell>
        </van-col>
<!--        <van-col span="24" class="creator_agency_information_bg_office">-->
<!--          <van-cell is-link>-->
<!--            <template #title>-->
<!--              <img src="../assets/img/creator/creator_agency_user_id.png" class="creator_agency_information_bg_office_img"/>-->
<!--              <span class="custom-title">{{ $t('column.face_id')}}</span>-->
<!--            </template>-->
<!--            <template #default>-->
<!--              <span class="custom-title">{{ userinfo.status == '1' ? $t('Tips.Certified') : $t('Tips.Not_certified') }}</span>-->
<!--            </template>-->
<!--          </van-cell>-->
<!--        </van-col>-->
      </van-col>
      <van-col span="22" offset="1" class="creator_agency_yellow">
        <van-col span="24" class="creator_agency_yellow_bg">
          <span>{{ $t('column.total')}}:</span><img src="../assets/img/coin9.png"/><span class="creator_agency_yellow_bg_coin">{{ userinfo.total }}</span>
        </van-col>
        <van-col span="24">
          <van-col span="12" class="creator_agency_yellow_bg_left">
            <van-col span="24" class="creator_agency_yellow_bg_left_name">{{ $t('column.myself_income')}} </van-col>
            <van-col span="24" class="creator_agency_yellow_bg_left_val"><img src="../assets/img/coin9.png"/> {{ userinfo.basic_income }}</van-col>
          </van-col>
          <van-col span="12" class="creator_agency_yellow_bg_left">
            <van-col span="24" class="creator_agency_yellow_bg_left_name">{{ $t('column.creator_commission')}} </van-col>
            <van-col span="24" class="creator_agency_yellow_bg_left_val"><img src="../assets/img/coin9.png"/> {{ userinfo.bonus_income }}</van-col>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="24" class="creator_agency_tab">
        <van-tabs v-model="creator_active" @click="creator_active_btn">
          <van-tab title="CREATOR">
            <van-col span="9" offset="1" class="creator_agency_tab_top">
              <van-cell @click="date_show = true" is-link arrow-direction="down">
                <template #default>
                  <img src="../assets/img/creator/creator_agency_tab_time.png" class="creator_agency_tab_time"/>
                  <span class="custom-title">{{ creator_date }}</span>
                </template>
              </van-cell>
            </van-col>
            <van-col span="22" offset="1" class="creator_agency_commission">
              <van-col span="22" offset="1" class="creator_agency_commission_title"> {{ $t('column.creator_commission')}} </van-col>
              <van-col span="22" offset="1" class="creator_agency_commission_list">
                <van-cell value="History list" @click="jump_href" is-link>
                  <template #title>
                    <img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/>
                    <span class="custom-title">{{ count_bonus_income }}</span>
                  </template>
                </van-cell>
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="creator_agency_rate">
              <van-col span="22" offset="1" class="creator_agency_rate_time"> {{ progress_info.progress_date }} </van-col>
              <van-col span="22" offset="1" class="creator_agency_rate_value"> {{ $t('column.commission_rate')}}: <span>{{ progress_info.progress_ratio }}%</span> </van-col>
              <van-col span="22" offset="1" class="creator_agency_rate_progress">
                <van-progress :percentage="progress_sum" color="#A529FF" track-color="#F7F8FB" stroke-width="6" :show-pivot="false"/>
                <van-col span="24" class="creator_agency_rate_progress_text">
                  <div v-for="(item,i) in progress_list" :key="i" :style="{'width':progress_width}" :class="i === 0 ? 'creator_agency_rate_progress_text_line_left' : 'creator_agency_rate_progress_text_line'">
                    <div class="creator_agency_rate_progress_text_top">{{ item.rate}}</div>
                    <div class="creator_agency_rate_progress_text_bottom"><img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/>{{ item.level_name }}</div>
                  </div>
                </van-col>
              </van-col>
              <van-col span="22" offset="1" class="creator_agency_rate_text">
                <van-col span="3" class="creator_agency_rate_text_img">
                  <img src="../assets/img/creator/creator_agency_progress.png"/>
                </van-col>
                <van-col span="20" class="creator_agency_rate_text_centent">
                  <van-col span="24" class="creator_agency_rate_text_centent_title">
                    {{ $t('column.earnings_in_past_30days')}}: <img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/> {{ progress_info.progress_income }}
                  </van-col>
                  <van-col span="24" class="creator_agency_rate_text_centent_need">
                    {{ $t('column.need')}} <img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/> <span class="creator_agency_rate_text_centent_need_coin">{{ progress_info.progress_balance }}</span> {{ $t('column.to_progress_to_next_level')}} <span class="creator_agency_rate_text_centent_need_b">{{ progress_info.progress_next_ratio }}%</span>
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="creator_agency_user">
              <van-col span="10" class="creator_agency_user_left">
                <van-cell is-link arrow-direction="down" @click="sexShow=true">
                  <template #default>
                    <span class="custom-title">{{getSexText()}}</span>
                  </template>
                </van-cell>
              </van-col>
              <van-col span="12" offset="1" class="creator_agency_user_right">
                <van-search
                    v-model="search_user_id"
                    shape="round"
                    background="unset"
                    @search="search_btn"
                    :placeholder="$t('column.search_user_id')"
                />
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="creator_agency_user_list">
              <van-col span="24" class="creator_agency_user_list_val" v-for="(item,j) in user_list" :key="j">
                <van-col span="6" class="creator_agency_user_list_val_avatar">
                  <van-image
                      round
                      width="12vw"
                      height="12vw"
                      :src="item.head_image"
                  />
                </van-col>
                <van-col span="12" class="creator_agency_user_list_val_centent">
                  <van-col span="24" class="creator_agency_user_list_val_centent_name">  {{ item.nick_name }} <van-icon name="arrow" size="12px"/></van-col>
                  <van-col span="24" class="creator_agency_user_list_val_centent_id"> ID: {{ item.user_id }}</van-col>
                </van-col>
                <van-col span="5" class="creator_agency_user_list_val_right">
                  <img src="../assets/img/creator/creator_agency_message.png" @click="privateMessage(item.user_id)"/>
                </van-col>
                <van-col span="22" offset="1">
                  <van-col span="12" class="creator_agency_user_list_val_commission">
                    <van-col span="24" class="creator_agency_user_list_val_commission_title">{{ $t('column.my_commission')}}</van-col>
                    <van-col span="24" class="creator_agency_user_list_val_commission_coin">
                      <img src="../assets/img/coin9.png"/> {{ item.creator_income }}
                    </van-col>
                  </van-col>
                  <van-col span="12" class="creator_agency_user_list_val_commission">
                    <van-col span="24" class="creator_agency_user_list_val_commission_title">{{ $t('column.creator_earnings')}}</van-col>
                    <van-col span="24" class="creator_agency_user_list_val_commission_coin">
                      <img src="../assets/img/coin9.png"/> {{ item.basic_income }}
                    </van-col>
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
          </van-tab>
          <van-tab title="MYSELF">
            <!-- 日期选择器 -->
            <van-col span="9" offset="1" class="creator_agency_tab_top">
              <van-cell @click="date_show = true" is-link arrow-direction="down">
                <template #default>
                  <img src="../assets/img/creator/creator_agency_tab_time.png" class="creator_agency_tab_time"/>
                  <span class="custom-title">{{ creator_date }}</span>
                </template>
              </van-cell>
            </van-col>

            <!-- Tab切换按钮 -->
            <van-col span="22" offset="1" class="myself_tab_buttons">
              <van-col span="8" class="myself_tab_button" :class="{'myself_tab_active': myself_active_tab === 'daily'}" @click="myself_active_tab_btn('daily')">
                {{ $t('column.daily_income')}}
              </van-col>
              <van-col span="8" offset="1" class="myself_tab_button" :class="{'myself_tab_active': myself_active_tab === 'room'}" @click="myself_active_tab_btn('room')">
                {{ $t('column.room_data')}}
              </van-col>
            </van-col>
            <!-- 每日数据 -->
            <van-col span="24" v-if="myself_active_tab === 'daily'">
              <van-col span="22" offset="1" class="creator_user_daily_income" v-for="(item,i) in daily_income_list" :key="i">
                <van-col span="22" offset="1" class="creator_user_daily_income_time">
                  <van-cell :title="item.date" is-link  @click="jumpDaily(item.date_ymd)"/>
                </van-col>
                <van-col span="22" offset="1" class="creator_user_daily_income_time">
                  <van-col span="8">
                    <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.total')}}</van-col>
                    <van-col span="24" class="creator_user_daily_income_time_coin"> <img src="../assets/img/coin9.png"/>{{ item.total }}</van-col>
                  </van-col>
                  <van-col span="8">
                    <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.basic_income')}}</van-col>
                    <van-col span="24" class="creator_user_daily_income_time_coin2"> <img src="../assets/img/coin9.png"/>{{ item.basic_income }}</van-col>
                  </van-col>
                  <van-col span="8">
                    <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.bonus_ncome')}}</van-col>
                    <van-col span="24" class="creator_user_daily_income_time_coin2"> <img src="../assets/img/coin9.png"/>{{ item.bonus_ncome }}</van-col>
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
            <!-- 直播数据 -->
            <van-col span="22" offset="1" class="myself_data_table" v-else>
              <!-- 表头 -->
              <van-col span="24" class="myself_table_header">
                <van-col span="24" class="myself_section_header">
                  <van-col span="12" class="myself_section_title" :class="{'myself_room_tab_active': room_type_tab === 'live'}" @click="room_type_tab = 'live'">{{ $t('column.live_room')}}</van-col>
                  <van-col span="12" class="myself_section_title" :class="{'myself_room_tab_active': room_type_tab === 'chat'}" @click="room_type_tab = 'chat'">{{ $t('column.chat_room')}}</van-col>
                </van-col>
                <van-col span="24" class="myself_column_header" v-if="room_type_tab === 'chat'">
                  <van-col span="6" class="myself_column_cell">{{ $t('column.date') }}</van-col>
                  <van-col span="6" class="myself_column_cell">{{ $t('column.mic_duration')}}<br>({{ $t('column.mins')}})</van-col>
                  <van-col span="6" class="myself_column_cell">{{ $t('column.chat_room_gift')}}</van-col>
                  <van-col span="6" class="myself_column_cell">{{ $t('column.chat_room_gift')}}<br>({{$t('column.myself')}})</van-col>
                </van-col>
                <van-col span="24" class="myself_column_header" v-else>
                  <van-col span="8" class="myself_column_cell">{{ $t('column.date') }}</van-col>
                  <van-col span="8" class="myself_column_cell">{{ $t('column.mic_duration')}}<br>({{ $t('column.mins')}})</van-col>
                  <van-col span="8" class="myself_column_cell">{{ $t('column.chat_room_gift')}}<br>({{$t('column.myself')}})</van-col>
                </van-col>
              </van-col>
              <!-- 表数据 chat room -->
              <van-col span="24" class="myself_table_body" v-if=" room_type_tab === 'chat'">
                <van-col span="24" class="myself_table_row" v-for="(item, index) in chat_data_list" :key="index">
                  <van-col span="6" class="myself_data_cell">{{ item.date }}</van-col>
                  <van-col span="6" class="myself_data_cell">{{ item.duration }}</van-col>
                  <van-col span="6" class="myself_data_cell">
                    <img src="../assets/img/coin9.png" class="myself_coin_icon"/>{{ item.chat_income }}
                  </van-col>
                  <van-col span="6" class="myself_data_cell">
                    <img src="../assets/img/coin9.png" class="myself_coin_icon"/>{{ item.bonus_income }}
                  </van-col>
                </van-col>
              </van-col>
              <!-- 表数据 live room -->
              <van-col span="24" class="myself_table_body" v-else>
                <van-col span="24" class="myself_table_row" v-for="(item, index) in live_data_list" :key="index">
                  <van-col span="8" class="myself_data_cell">{{ item.date }}</van-col>
                  <van-col span="8" class="myself_data_cell">{{ item.duration }}</van-col>
                  <van-col span="8" class="myself_data_cell">
                    <img src="../assets/img/coin9.png" class="myself_coin_icon"/>{{ item.bonus_income }}
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
          </van-tab>
        </van-tabs>
      </van-col>
    </van-row>
    <!-- 日期选择器弹窗 -->
    <van-popup v-model="date_show" position="bottom" :style="{ height: '40%',width: '100%' }">
      <van-datetime-picker
        v-model="date_picker"
        :min-date="minDate"
        :max-date="maxDate"
        type="year-month"
        :title="$t('column.select_date')"
        :confirm-button-text="$t('btn.confirm')"
        :cancel-button-text="$t('btn.cancel')"
        @confirm="onMyselfDateConfirm"
        @cancel="date_show = false"
      />
    </van-popup>
    <van-popup v-model="sexShow" position="bottom" :style="{ height: '40%',width: '100%' }">
      <van-picker
          show-toolbar
          :title="$t('column.gender')"
          :columns="genderOptions"
          :confirm-button-text="$t('btn.confirm')"
          :cancel-button-text="$t('btn.cancel')"
          @confirm="onConfirm"
          @cancel="sexShow = false"
      />
    </van-popup>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import uploadImage from '@/components/upload_image.vue';
import {Dialog, DatetimePicker} from "vant";

export default {
  components: { uploadImage, DatetimePicker },
  data() {
    return {
      creator_date: undefined,
      date_show: false,
      creator_active: 0,
      date_picker: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(new Date().setHours(23,59,59,999)),
      myself_active_tab: 'daily', // 'daily' 或 'room'
      room_type_tab: 'live', // 'live' 或 'chat'
      chat_data_list: [],
      live_data_list: [],
      daily_income_list:[],
      progress_list: [],
      progress_width: '0%',
      progress_ratio: 0,
      progress_sum: 0,
      user_list: [],
      sexShow: false,
      userinfo: {},
      search_user_id: undefined,
      progress_info: {},
      count_bonus_income: 0,
      selectedSex: 0, // 默认选择(0)
      genderOptions: [
        { text:  this.$t('column.sex1_creator'), value: 1 },
        { text:  this.$t('column.sex2_creator'), value: 2 },
        { text: this.$t('column.all_creator'), value: 0 }
      ]
    }
  },
  created() {
    let year = this.date_picker.getFullYear();
    let month = this.date_picker.getMonth() + 1;
    this.creator_date = year + '-' + month
    // this.getList()
    this.getTabList()
  },
  methods: {
    jumpDaily(date) {
      // 跳转
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: '/creator_daily_income', query: {uid: uid, token: token, date: date}})
    },
    jump_href() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/creator_agency_history', query: { uid: uid, token: token} });
    },
    getSexText() {
      const gender = this.genderOptions.find(item => item.value === this.selectedSex);
      return gender ? gender.text : '';
    },
    onConfirm(value) {
      this.selectedSex = value.value;
      this.sexShow = false;
      this.getTabList()
    },
    getTabList(){
      console.log('getTabList: ' + this.creator_active)
      if(this.creator_active === 1) {
        this.incomelist()
      }else{
        this.getUserList()
        this.getList()
      }
    },
    creator_active_btn() {
      this.getTabList()
    },
    search_btn() {
      this.getTabList()
    },
    myself_active_tab_btn(val){
      this.myself_active_tab = val
      this.getTabList()
    },
    markPosition() {
      const index = this.progress_list.length - 1
      this.progress_width = (100 / index) + '%'
    },
    privateMessage(user_id) {
      // 拦截跳转私信
      window.location.href="live://live?action=JumpUserPrivateMessage&id=" + user_id
    },
    getUserList() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_under_creator",{
        params:{ uid: uid, token: token,search_user_id: this.search_user_id,date:this.creator_date,sex:this.selectedSex}
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.user_list = res.data.data.list
          this.count_bonus_income = res.data.data.count_bonus_income
        }else{
          Toast(res.data.error)
        }
      })
    },
    getList(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_center",{
        params:{ uid: uid, token: token, date: this.creator_date }
      }).then(res =>{
        if(res.data.status===1){
          this.userinfo = res.data.data.user_info
          this.progress_info = res.data.data.progress_info
          this.progress_sum = parseInt(res.data.data.progress_info.progress_sum)
          this.progress_list = res.data.data.progress_list
          this.markPosition()
        }else{
          Toast(res.data.error)
        }
      })
    },
    incomelist() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_center_income",{
        params:{uid: uid, token: token, date: this.creator_date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.daily_income_list = res.data.data.daily_income_list
          this.chat_data_list = res.data.data.room_income_list
          this.live_data_list = res.data.data.live_room_income_list
        }else{
          Toast(res.data.error)
        }
      })
    },
    copyId() {
      const element = document.getElementById("creator_user_id");
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    // MYSELF tab 相关方法
    onMyselfDateConfirm(value) {
      const year = value.getFullYear()
      const month = String(value.getMonth() + 1).padStart(2, '0')
      this.creator_date = `${year}-${month}`
      this.date_show = false
      // 在这里可以根据日期重新获取数据
      this.getTabList()
    }
  }
}
</script>

<style>
/* MYSELF tab 样式 */
.myself_tab_buttons {
  background: #f5f5f5;
  border-radius: 8px;
  margin-top: 3vw;
  display: flex;
}

.myself_tab_button {
  text-align: center;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.myself_tab_active {

  color: #A529FF;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.myself_data_table {
  background: #fff;
  border-radius: 12px;
  margin-top: 3vw;
  margin-bottom: 8vw;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.myself_table_header {
  background: #f8f9fa;
}

.myself_section_header {
  border-bottom: 1px solid #e9ecef;
}

.myself_section_title {
  text-align: center;
  padding: 12px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #999999;
  border-right: 1px solid #e9ecef;
  position: relative;
}

.myself_section_title:last-child {
  border-right: none;
}

.myself_column_header {
  background: #fff;
}

.myself_column_cell {
  text-align: center;
  padding-top: 2vw;
  height: 12vw;
  font-size: 0.8rem;
  color: #666;
  line-height: 4vw;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
}

.myself_column_cell:last-child {
  border-right: none;
}


.myself_table_row {
  border-bottom: 1px solid #f0f0f0;
}

.myself_table_row:last-child {
  border-bottom: none;
}

.myself_data_cell {
  text-align: center;
  padding: 12px 6px;
  font-size: 13px;
  color: #333;
  border-right: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
}

.myself_data_cell:last-child {
  border-right: none;
}

.myself_coin_icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  vertical-align: middle;
}

/* 响应式调整 */
@media (max-width: 480px) {

  
  .myself_data_cell {
    padding: 10px 4px;
    font-size: 12px;
    min-height: 44px;
  }
  
  .myself_coin_icon {
    width: 14px;
    height: 14px;
    margin-right: 2px;
  }
}

/* 确保表格在小屏幕上可滚动 */
.myself_data_table {
  overflow-x: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/creator_agency.vue